import { idBaseURL, isSuccess, option } from '../utils/fetch';
import {
  failureGetAgreements,
  successGetAgreements,
  successPostAgreements,
} from '../actions/termsOfServiceAgreements';
import * as c from '../constants/termsOfServiceAgreements';

/**
 * 利用規約同意が必要なバージョンを取得する
 */
export const getTermsOfServiceAgreements = () => async (dispatch) => {
  const op = await option.json();
  return fetch(idBaseURL() + '/users/terms-of-service/agreement/need-agree', op)
    .then((response) => isSuccess(response))
    .then((json) => dispatch(successGetAgreements(json)))
    .catch((error) => dispatch(failureGetAgreements(error.message)));
};

/**
 * 利用規約同意状態を登録する
 */
export const sendAgreement = () => async (dispatch) => {
  const isAgree = true;
  const body = {
    isAgree,
    version: c.REQUIRED_VERSION,
  };
  const op = await option.json('POST', body);
  return fetch(idBaseURL() + '/users/terms-of-service/agreement', op)
    .then((response) => isSuccess(response))
    .then((json) => dispatch(successPostAgreements(json)));
};
